/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentFarmerAccount } from '../../../azure-b2c/storage';
import Typography from '../../../../components/Typography';
import ClickableContactNumber from '../../../../components/ClickableContactNumber';
import { CardContent, Paper, Stack, useTheme } from '@mui/material';
import { AlternateEmailOutlined } from '@mui/icons-material';

const ContactDetailDisplay: FC = (): JSX.Element => {
  const farmerAccount = useSelector(selectCurrentFarmerAccount);
  const theme = useTheme();

  return (
    <Paper
      sx={{
        borderRadius: '1rem',
        width: { xs: '100%', lg: 272 },
        backgroundColor: theme.colors.primary50,
      }}
      elevation={0}
      className='farmlands-v2'
    >
      <CardContent sx={{ paddingTop: 3 }}>
        <Typography variant='h4' fontSize='1.25rem' color='shade100' fontWeight={700}>
          Primary Contact
        </Typography>
        <Stack gap={1}>
          <Typography fontSize='1rem' color='primary500' fontWeight={700}>{farmerAccount?.contact?.name}</Typography>
          {farmerAccount?.contact?.email ? (
            <Stack gap={1} flexDirection='row' alignItems='center'>
              <AlternateEmailOutlined color='disabled' />
              <Typography fontSize={16}>{farmerAccount.contact.email}</Typography>
            </Stack>
          ) : null}
          <ClickableContactNumber phone={farmerAccount?.contact?.phone ?? ''} />
        </Stack>
      </CardContent>
    </Paper>
  );
};

export default ContactDetailDisplay;
